import type { NotificationEmailCategory, NotificationGroup, NotificationPage } from "@globalbridge/types";

/** The notifications primitives' words (mock notifications-mock). */
export const NOTIF_PAGE_LABEL: Record<NotificationPage, string> = {
  products: "Products",
  sales: "Sales",
  returns: "Returns",
  orders: "Orders",
  finances: "Finances",
  reports: "Reports",
};

export const MARKETPLACE_LABEL = { nordstrom: "Nordstrom", macys: "Macy's" } as const;

export const NOTIF_GROUPS: ReadonlyArray<[NotificationGroup, string, string]> = [
  ["needs", "Needs you", "Something to do. It stays here until it is handled."],
  ["updates", "Updates", "What moved since your last visit."],
  ["done", "Done", "Finished in the last 30 days."],
];

export const NOTIF_EMAIL_ROWS: ReadonlyArray<[NotificationEmailCategory, string, string]> = [
  ["needs", "Something needs you", "A marketplace refused a price or a product, or an export failed."],
  ["requests", "Your requests", "Discounts, new prices, promotions and content: received, done or refused."],
  ["shipments", "Shipments", "The warehouse system picks up your notice. GB cancels one."],
  ["weekly", "Weekly check", "Monday morning: what changed in sales, returns and stock."],
  ["orders", "Orders", "A marketplace cancels orders."],
];

